import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import { 
  CallIcon, 
  ClockIconV3, 
  PersonIcon 
} from "../../../images/icons/icons";
import { formatDateTime } from "../../common-data/Converts";

const PendingBCALogCards = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((bcaLog, index) => {
          return (
            <div
              className="log-card"
              key={index}
              style={{ overflow: "hidden", paddingBottom: "8px" }}
            >
              <div className="all-info">
                 <div className="log-card-top">
                   <div className="profile-name-number" style={{height: "auto", minHeight: "auto"}}>
        
                     <div className="name-number" style={{height: "auto", minHeight: "auto", flex: "1"}}>
                       <h3 className="lead-name" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                         <PersonIcon /> {bcaLog?.user_name || "NA"}
                       </h3>
                       <p className="number" style={{display: "flex", alignItems: "center", gap: "6px",marginTop:"px"}}>
                         <CallIcon /> {bcaLog?.user_mobile || "NA"}
                       </p>
                       <span className="value gym-name semi-bold">
                         {bcaLog?.gym_name || "NA"}
                       </span>
                       <span className="value semi-bold" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                         <PersonIcon /> Trainer: {bcaLog?.trainer_name || "NA"}
                       </span>
                       <span className="value semi-bold" style={{display: "flex", alignItems: "center", gap: "6px"}}>
                        <ClockIconV3 color="#2c3e50" /> Check-in: {formatDateTime(bcaLog?.date_added || "-")}
                       </span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default PendingBCALogCards;
